export class CreateGatewayCustomer {
    name: string
    document: string
    phone: string
    email: string
    addressCEP: string
    addressStreet: string
    addressNumber: string
    addressNeighborhood: string
    addressCity: string
    addressState: string
    addressComplement?: string
}
